import { CustomerSupportRoutes } from '@leagueplatform/cse-customer-support';
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import {
  CSAuthSessionContainer,
  CSAuthSignIn,
  CSAuthSignOut,
} from '@highmark-web/highmark-common';

const routes: RouteObject[] = [
  { path: '/start-login', element: <CSAuthSignIn /> },
  { path: '/sign-out', element: <CSAuthSignOut /> },
  {
    path: '',
    element: <CSAuthSessionContainer />,
    children: [
      { path: '/customer-support/*', element: <CustomerSupportRoutes /> },
      { path: '', element: <Navigate to="/customer-support" replace /> },
    ],
  },
];

export const AppRoutes = () => useRoutes(routes);
